const getArcPath = (outerR: number, innerR: number, degrees: number) => {
  const theta = degrees * (Math.PI / 180);

  const outerX1 = outerR * Math.cos(0);
  const outerY1 = outerR * Math.sin(0);
  const outerX2 = outerR * Math.cos(theta);
  const outerY2 = outerR * Math.sin(theta);

  const innerX1 = innerR * Math.cos(theta);
  const innerY1 = innerR * Math.sin(theta);
  const innerX2 = innerR * Math.cos(0);
  const innerY2 = innerR * Math.sin(0);

  // Large arc flag: determines if the arc should be greater than 180 degrees
  const largeArcFlag = degrees > 180 ? 1 : 0;

  return `
        M ${outerX1},${outerY1}
        A ${outerR},${outerR} 0 ${largeArcFlag},1 ${outerX2},${outerY2}
        L ${innerX1},${innerY1}
        A ${innerR},${innerR} 0 ${largeArcFlag},0 ${innerX2},${innerY2}
        Z
    `;
};

const Arc: React.FC<{
  outerRadius: number;
  innerRadius: number;
  angle: number;
  color?: string;
}> = ({
  outerRadius,
  innerRadius,
  angle,
  color = "rgba(var(--color-accent), 0.7)",
}) => {
  if (angle === 0) return null;

  const d = outerRadius * 2;
  const path = getArcPath(outerRadius, innerRadius, angle);

  return (
    <svg
      width={d}
      height={d}
      style={{ rotate: "-90deg" }}
      viewBox={`-${outerRadius} -${outerRadius} ${d} ${d}`}
    >
      <path d={path} fill={color} stroke="none" />
    </svg>
  );
};
export default Arc;
